<template>
    <div>
        <div class="fixed-bg-overlay"></div>
        <div class="bg-blur" :style="{backgroundImage: 'url(' + require('@/assets/img/base/bg-blur.jpg') + ')'}"></div>

        <v-navigation-drawer v-if="isMobile" v-model="filtersDrawer" absolute temporary touchless>
            <div class="pa-2" style="margin-top: 64px">
                <accounts-filter
                    ref="filters"
                    :has-filters="hasFilters"
                    @specialties="onSpecialtyChange"
                    @clear="clearAllFilters"
                    @apply="applyFilters"
                />
            </div>
        </v-navigation-drawer>

        <v-container>
            <v-layout wrap justify-center align-start>
                <!-- TITLE -->
                <v-flex xs12>
                    <w-main-title title="Servicios" :breadcrumbs="breadcrumbs"></w-main-title>
                </v-flex>

                <!-- FILTERS -->
                <v-flex md4 xl3 pa-2 v-if="!isMobile">
                    <v-layout wrap justify-start align-start>
                        <accounts-filter
                            ref="filters"
                            :has-filters="hasFilters"
                            @specialties="onSpecialtyChange"
                            @clear="clearAllFilters"
                            @apply="applyFilters"
                        />
                        <div class="total-card">
                            Total UF <b>{{ totalAmounts }}</b> mensuales
                        </div>
                    </v-layout>
                </v-flex>

                <!-- CONTENT -->
                <v-flex xs12 md8 xl9 text-xs-center pa-2>
                    <!-- FILTERS -->
                    <v-layout wrap align-center justify-center>
                        <!-- SEARCH -->
                        <v-flex xs12 text-xs-center>
                            <v-text-field
                                v-if="isMobile"
                                class="ma-2"
                                hide-details
                                height="50"
                                prepend-inner-icon="search"
                                append-outer-icon="fa-filter"
                                outline
                                v-model="search"
                                label="Búsqueda rápida"
                                placeholder="Institución / Centro"
                                clearable
                                @keyup.enter="applyFilters"
                                @click:clear="clearSearch"
                                @click:append-outer="showFilters"
                            />
                            <v-text-field
                                v-else
                                class="ma-2"
                                hide-details
                                height="50"
                                append-icon="search"
                                outline
                                v-model="search"
                                label="Búsqueda rápida"
                                placeholder="Institución / Centro"
                                clearable
                                @keyup.enter="applyFilters"
                                @click:clear="clearSearch"
                                @click:append="applyFilters"
                            />
                        </v-flex>

                        <!-- FILTER TYPE -->
                        <v-flex xs12 text-xs-center>
                            <div class="text-xs-center flex-center">
                                <v-radio-group height="15" v-model="typeFilter" row>
                                    <v-radio color="accent" label="Todo" value="" checked></v-radio>
                                    <v-radio color="accent" label="Centros" value="institutions"></v-radio>
                                    <v-radio color="accent" label="Especialistas" value="specialists"></v-radio>
                                </v-radio-group>
                            </div>

                        </v-flex>

                        <!-- SHOW CURRENT FILTERS -->
                        <v-flex xs12 text-xs-center>
                            <v-sheet color="transparent" height="30">
                                <!-- SPECIALTIES -->
                                <v-chip v-model="specialtyChip" color="primary" hover dark close>
                                    Especialidad: {{ specialtyFilter.length > 0 ? specialtyFilter[0].name : '' }}
                                    {{
                                        specialtyFilter.length > 1 ? '(' + (specialtyFilter.length - 1).toString() + '+)' : ''
                                    }}
                                </v-chip>
                            </v-sheet>
                        </v-flex>
                    </v-layout>
                    <!-- RESULTS -->
                    <v-layout wrap justify-center align-center>
                        <!-- LOADING -->
                        <v-flex xs12 pa-4 text-xs-center v-if="loading && !items.length">
                            <v-progress-circular width="2" indeterminate color="primary" size="70" class="mt-4"/>
                        </v-flex>
                        <!-- NO RESULTS -->
                        <v-flex xs12 pa-4 text-xs-center v-if="noResults" class="mt-4">
                            <span class="font-weight-regular">
                                No se encontraron coincidencias.
                            </span>
                            <v-icon>far fa-frown</v-icon>
                        </v-flex>
                        <!-- RESULTS ITEMS -->
                        <v-flex xs12 mt-3>
                            <provider-list-item
                                v-for="(item, i) in items"
                                :key="i" class="mt-1"
                                @click="goToAccount"
                                @config="showProviderAccount"
                                :item="item"
                            />
                        </v-flex>
                        <!-- LOAD MORE BUTTON -->
                        <v-flex xs12 pa-4 text-xs-center v-if="!loading && moreItemsLink && items.length">
                            <v-sheet height="80" color="transparent">
                                <v-btn
                                    depressed round flat large
                                    color="black" :disabled="loading"
                                    @click="getMoreSpecialists"
                                >
                                    Cargar mas
                                </v-btn>
                                <v-flex xs12>
                                    <v-icon @click="getMoreSpecialists">fas fa-chevron-down</v-icon>
                                </v-flex>
                            </v-sheet>
                        </v-flex>
                        <!-- LOADING MORE -->
                        <v-flex xs12 pa-4 text-xs-center v-if="loading && items.length">
                            <v-sheet height="80" color="transparent">
                                <v-progress-circular width="2" indeterminate color="primary" size="30" class="mt-4"/>
                            </v-sheet>
                        </v-flex>
                    </v-layout>

                </v-flex>
            </v-layout>
        </v-container>

        <provider-subscription ref="subscriptionForm"></provider-subscription>
    </div>
</template>

<script>
import AccountsFilter from "@/components/admin/AccountsFilter";
import WMainTitle from '@/components/common/WMainTitle'
import ProviderListItem from '@/components/providers/ProviderListItem'
import ProviderSubscription from '@/components/providers/ProviderSubscription'

import {debounce} from '@/utils/Common'
import {ApiUtils} from '@/utils/ApiUtils'

import {mapState, mapMutations} from 'vuex'

export default {
    components: {
        AccountsFilter,
        WMainTitle,
        ProviderListItem,
        ProviderSubscription
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: 'Inicio',
                    disabled: false,
                    to: 'panel/dashboard'
                },
                {
                    text: 'Servicios',
                    disabled: true,
                    to: ''
                },
            ],
            filtersDrawer: false,
            filtersWereChanged: false,
            search: '',
            loading: true,
            noResults: false,
            specialtyChip: false,
            specialtyFilter: [],
            typeFilter: '',
            items: [],
            moreItemsLink: null,
        }
    },
    computed: {
        ...mapState(['currentUser',]),
        hasFilters(vm = this) {
            return vm.specialtyFilter.length > 0
        },
        specialtyChip(vm = this) {
            return vm.specialtyFilter.length > 0 || false
        },
        totalAmounts(vm = this) {
            let amount = 0
            vm.items.forEach(item => {
                amount += item.subscription_plan && item.subscription_plan.amount || 0
            })
            return amount
        }
    },
    mounted() {
        const vm = this
        vm.checkFiltersShowByQuery()
        vm.fillFiltersFromQuery()
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        goToAccount(provider) {
            this.$router.push({name: 'provider.profile', params: {id: provider.id}})
        },
        showProviderAccount(id) {
            this.$refs.subscriptionForm.showDialog(id)
        },
        setFiltersWereChanged() {
            const vm = this
            if (vm.filtersDrawer) vm.filtersWereChanged = true
        },
        fillFiltersFromQuery() {
            const vm = this
            const query = vm.$route.query
            if (Object.keys(query).length === 0) return vm.getProviders()
            if (query.specialty) vm.specialtyFilter = query.specialty.split(',')
            if (query.name) vm.search = query.name
            vm.getProviders()
        },
        checkFiltersShowByQuery() {
            const vm = this
            if (vm.$route.query.show_filters && vm.$route.query.show_filters === 'true') vm.showFilters()
        },
        clearAllFilters() {
            this.$refs.filters.$refs.specialtySelector.clear()
            this.applyFilters()
        },
        debounceApplyFilter: debounce(function (showDrawer = false) {
            this.applyFilters(showDrawer)
        }, 500),
        debounceGetProviders: debounce(function () {
            this.getProviders()
        }, 500),
        applyFilters(showDrawer = false) {
            const vm = this

            vm.items = []
            vm.moreItemsLink = null

            const filters = {
                specialty: vm.specialtyFilter.map(s => s.id).join(','),
                name: vm.search,
                show_filters: showDrawer,
                only: vm.typeFilter
            }

            vm.filtersWereChanged = false

            vm.$router.push({
                query: filters
            })

            vm.$nextTick(() => {
                vm.getProviders()
            })
        },
        showFilters() {
            this.filtersDrawer = true
        },
        clearSearch() {
            const vm = this
            vm.search = ''
            vm.applyFilters()
        },
        async getProviders(url = '') {
            const vm = this
            vm.noResults = false
            const filters = {
                service_items: vm.specialtyFilter.map(specialty => specialty.id).join(','),
                with_ratings: 1,
                with_service_item: 1,
                name: vm.search,
                only: vm.typeFilter
            }

            vm.loading = true
            const response = url ? await ApiUtils.makeGet(url) :
                await ApiUtils.makeGet('public/providers', filters)
            vm.loading = false

            if (!response.ok) return vm.showSnackBar('Error intentando cargar proveedores')

            const json = await response.json()
            vm.items = vm.items.concat(json.result.providers.data)
            vm.moreItemsLink = json.result.providers.next_page_url
        },
        getMoreSpecialists() {
            const vm = this
            if (!vm.moreItemsLink) return
            vm.getProviders(vm.moreItemsLink)
        },
        onSpecialtyChange(specialty) {
            this.specialtyFilter = specialty;
        },
    },
    watch: {
        filtersDrawer(val) {
            if (!val && this.filtersWereChanged) this.applyFilters()
        },
        search(val) {
            if ((val && val.length > 3) || !val) this.debounceApplyFilter()
        },
        typeFilter() {
            this.debounceApplyFilter()
        },
        specialtyChip(val) {
            const vm = this
            vm.setFiltersWereChanged()
            if (!val) {
                vm.$refs.filters.$refs.specialtySelector.clear()
                vm.debounceApplyFilter()
            }
        },
        items(val) {
            const vm = this
            vm.noResults = val && val.length === 0
        }
    },
}
</script>

<style scoped>

.flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bg-blur {
    background-size: cover;
    background-attachment: fixed;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -2;
    opacity: .7;
}

.fixed-bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: .95;
    z-index: -1;
    pointer-events: none;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7db9e8+0,1e5799+36 */
    background: rgb(125, 185, 232); /* Old browsers */
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 50%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7db9e8', endColorstr='#1e5799', GradientType=0); /* IE6-9 */
}

.total-card {
    background: rgba(255, 255, 255, 0.3);
    padding: 8px 12px;
    border-radius: 8px;
    margin-top: 12px;
    border: 1px solid #333333;
    width: 100%;
}


</style>